import { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { onChangeFilters, clearAllTableFilters } from "../../../redux/features/table/tableSlice";
import { Row, Col, InputGroup, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import search from "../../../assets/images/icon_svg/search.svg";
import gray_circle from '../../../assets/images/common/gray_circle.png';
import blue_circle from '../../../assets/images/common/blue_circle.png';
import { ReactComponent as FilterIcon } from "../../../assets/images/icon_svg/filter.svg";

const TableFilterMorePanel = ({ config = [] }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.table);

  const hasFilters = Object.values(filters).some((value) => value && value.toString().trim() !== "");
  
  const [open, setOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [activeItem, setActiveItem] = useState(null);
  const [pending, setPending] = useState({});

  const [searchForm, setSearchForm] = useState({});
  const [activeItems, setActiveItems] = useState([]);
  const [searchItem, seSearchItem] = useState("");

  const panelRef = useRef(null);
  const handleToggle = () => {
    if (!open) {
      // setPending({ ...filters });
      // setSearchText("");
      // setActiveItem(null);

      seSearchItem("");
    }
    if (hasFilters) {
      setSearchForm(prev => ({ ...prev, activeSec: '', activeLabel: '' }))
    } else {
      setSearchForm(prev => ({}))
    }
    setOpen((v) => !v);
  };

  useEffect(() => {
    const handler = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  const moreFields = config.flatMap((g) => g.items.map((i) => i.field));
  
  const activeMoreCount = moreFields.filter((f) => {
    const v = filters[f];
    return Array.isArray(v) ? v.length > 0 : v != null && v !== "";
  }).length;

  const getActiveItemConfig = () => config.find((grp) => grp.label === searchForm.activeSec)?.items.find((itm) => itm.label === searchForm.activeLabel);

  const optionChange = (field, value) => {
    setSearchForm(prev => {
      const current = prev[field] || [];
      const exists = current.includes(value)
      return {
        ...prev,
        [field]: exists ? current.filter((v) => v !== value) : [...current, value],
      }
    })
  };

  const handleApply = () => {
    // const { activeSec, activeLabel, ...rest } = searchForm
    const { activeSec, activeLabel, activeField, ...rest } = searchForm
    const filteredData = Object.fromEntries(   Object.entries(rest).map(([key, value]) => [     
    key,     
    !Array.isArray(value) &&
    value !== null &&
    typeof value === "object" ? true: value  ]) );
 
    dispatch(onChangeFilters(filteredData));
    setOpen(false);
  };

  const handleReset = () => {
    dispatch(onChangeFilters({}));
    setOpen(false);
    setSearchForm({})
  };

  const handleItemSerch = (value) => {
    const search = value.toLowerCase();
    seSearchItem(value)
    const findItems = config?.find(grp => grp.label === searchForm.activeSec)?.items?.find(itm => itm.label === searchForm.activeLabel)?.options;
    if (!search) {
      setActiveItems(findItems);
      return;
    }

    const result = findItems.filter(item =>
      item.label.toLowerCase().startsWith(search)
    );

    setActiveItems(result);
  } 

  // No Need
  // 

  // const currentItem = activeItem
  //   ? config
  //     .find((g) => g.value === activeItem.groupValue)
  //     ?.items.find((i) => i.field === activeItem.itemField)
  //   : null;

  // const itemHasPending = (field) => {
  //   const v = pending[field];
  //   return Array.isArray(v) ? v.length > 0 : v != null && v !== "";
  // };

  // const toggleOption = (field, value) => {
  //   setPending((prev) => {
  //     const current = prev[field] || [];
  //     const exists = current.includes(value);
  //     return {
  //       ...prev,
  //       [field]: exists ? current.filter((v) => v !== value) : [...current, value],
  //     };
  //   });
  // };


  // const handleApply = () => {
  //   dispatch(onChangeFilters(pending));
  //   setOpen(false);
  // };

  // const handleReset = () => {
  //   const cleared = { ...pending };
  //   moreFields.forEach((f) => delete cleared[f]);
  //   setPending(cleared);
  //   dispatch(onChangeFilters(cleared));
  //   setOpen(false);
  // };


  // const filteredConfig = config.map((group) => ({
  //   ...group,
  //   items: group.items.filter((item) => item?.label?.toLowerCase().includes(searchText.toLowerCase())),
  // })).filter((group) => group.items.length > 0);

  // const filteredOptions = (currentItem?.options || []).filter((opt) =>
  //   opt?.label?.toLowerCase().includes(rightSearch.toLowerCase())
  // );
  const activeItemConfig = getActiveItemConfig();
  // const fieldKey = searchForm.activeLabel?.toLowerCase();
  const fieldKey = searchForm?.activeField;
  return (
    <div ref={panelRef} style={{ position: "relative" }}>
      {/* {console.log('config', config)} */}
      <button
        onClick={handleToggle}
        title="More Filters"
        className={`filter ${activeMoreCount > 0 ? "has-active" : ""}`}
      >
        <FilterIcon />
        {activeMoreCount > 0 && (
          <span className="more-filter-badge">{activeMoreCount}</span>
        )}
      </button>

      {open && (
        <div className="more-filter-panel-wrap position-absolute">
          <div className="filter_tab_card m-0">
            <div className="left_part">
              <div className="p-3">
                <InputGroup className="mb-3">
                  <img src={search} alt="search" className="serach_icon search_img" />
                  <Form.Control
                    placeholder="Search filters…"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    autoFocus
                  />
                </InputGroup>
                {console.log('SF', searchForm)}
                <div className="item">
                  {config.map((group) => (
                    <div className="mb-2" key={group.value}>
                      <h6>{group.label}</h6>
                      <ul>
                        {group.items.map((item) => {
                          // const isActive =
                          //   activeItem?.groupValue === group.value &&
                          //   activeItem?.itemField === item.field;
                          // const hasPending = itemHasPending(item.field);
                          // const isActive = searchForm[item.label.toLowerCase()]?.length;
                            const isActive = searchForm[item.field] || searchForm[item.field]?.length;
                          return (
                            <li
                              key={item.field}
                              className={`list_group_item ${isActive ? "active" : ""}`}
                              onClick={() => {
                                // setActiveItem({
                                //   groupValue: group.value,
                                //   itemField: item.field,
                                // });
                                // setRightSearch("");
                                setSearchForm(prev => ({ ...prev, activeSec: group.label, activeLabel: item.label, activeField: item.field }))
                                setActiveItems(item.options)
                                seSearchItem("");
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <img
                                src={isActive ? blue_circle : gray_circle}
                                alt=""
                              />
                              {item.label}
                              <span>›</span>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {searchForm.activeLabel &&
              <div className="right_part">
                <div className="">
                  <h5>{searchForm?.activeLabel}</h5>
                  {/* {activeItemConfig?.type === "multiselect" && ( */}
                  {activeItemConfig?.type === "multiselect" && (
                  <InputGroup className="search_station_dv">
                    <img src={search} alt="search" className="serach_icon search_img" />
                    <Form.Control
                      placeholder={`Search ${searchForm?.activeLabel}`}
                      className="search_station"
                      value={searchItem}
                      onChange={(e) => handleItemSerch(e.target.value)}
                    />
                  </InputGroup>)}
                  {/* )} */}
                  <div className="originDstintnWrap">
                    {activeItemConfig?.type === "text" && (
                      <Form.Control
                        type="text"
                        placeholder={`Enter ${searchForm.activeLabel}…`}
                        value={searchForm[fieldKey] || ""}
                        onChange={(e) => setSearchForm(prev => ({ ...prev, [fieldKey]: e.target.value }))}
                        className="mt-2"
                      />
                    )}
                    {activeItemConfig?.type === "multiselect" && (
                      activeItems?.length === 0 ? (
                        <p className="no_option">
                        No options available
                        </p>
                    ) : (
                    activeItems?.map((opt, index) => {
                      // const checked = (pending[currentItem.field] || []).includes(opt.value);
                      const checked = searchForm[searchForm.activeLabel.toLowerCase()]?.includes(opt.value);
                      // console.log('checked', checked);
                        return (
                          <Form.Check
                            key={opt.value + '_' + index}
                            type="checkbox"
                            // id={`mfp-${currentItem.field}-${opt.value}`}
                            label={opt.label}
                            // checked={checked}
                            checked={(searchForm[fieldKey] || []).includes(opt.value)}
                            // onChange={() => toggleOption(currentItem.field, opt.value)}
                            // onChange={() => optionChange(searchForm.activeLabel.toLowerCase(), opt.value)}
                            onChange={() => optionChange(fieldKey, opt.value)}
                            className="mb-2"
                          />
                        );
                      })
                    ) )}
                    {activeItemConfig?.type === "date" && (
                      <Form.Control
                        type="date"
                        value={searchForm[fieldKey] || ""}
                        onChange={(e) => setSearchForm(prev => ({ ...prev, [fieldKey]: e.target.value }))}
                        className="mt-2"
                      />
                    )}
                   {activeItemConfig?.type === "range" && (
                    <div className="d-flex gap-2 mt-2">
                      <Form.Control
                        type="number"
                        placeholder="Min"
                        value={searchForm[fieldKey]?.min || ""}
                        onChange={(e) =>
                          // setSearchForm(prev => ({ ...prev, [`${fieldKey}_min`]: e.target.value }))
                          setSearchForm(prev => ({ ...prev, [fieldKey]: { ...prev[fieldKey], min: e.target.value }, [`${[fieldKey]}_min`]: e.target.value }))
                        }
                      />
                      <Form.Control
                        type="number"
                        placeholder="Max"
                        value={searchForm[fieldKey]?.max || ""}
                        onChange={(e) =>
                          // setSearchForm(prev => ({ ...prev, [`${fieldKey}_max`]: e.target.value }))
                          setSearchForm(prev => ({ ...prev, [fieldKey]: { ...prev[fieldKey], max: e.target.value }, [`${[fieldKey]}_max`]: e.target.value }))
                        }
                      />
                    </div>
                   )}
                </div>
                </div>
                <div className="filter_tab_footer">
                  <button className="reset_aply_btn" onClick={handleReset}>
                    Reset
                  </button>
                  <button className="apply_btn" onClick={handleApply}>
                    Apply Filter
                  </button>
                </div>
              </div>
            }
            {/* {currentItem && (
              <Col md={6} className="right_part">
              <div className="p-3">
                {currentItem ? (
                  <>
                    <h5 className="mb-3">{currentItem.label}</h5>
                    <InputGroup className="search_station_dv">
                      <img src={search} alt="search" className="serach_icon search_img" />
                      <Form.Control
                        placeholder={`Search ${currentItem.label}`}
                        className="search_station"
                        value={rightSearch}
                        onChange={(e) => setRightSearch(e.target.value)}
                      />
                    </InputGroup>
                    <div className="originDstintnWrap">

                      {filteredOptions.length === 0 ? (
                        <p style={{ fontSize: 12, color: "#98a2b3", padding: "12px 0" }}>
                          No options available
                        </p>
                      ) : (

                        filteredOptions.map((opt) => {
                          const checked = (pending[currentItem.field] || []).includes(opt.value);
                          return (
                            <Form.Check
                              key={opt.value}
                              type="checkbox"
                              id={`mfp-${currentItem.field}-${opt.value}`}
                              label={opt.label}
                              checked={checked}
                              onChange={() => toggleOption(currentItem.field, opt.value)}
                              className="mb-2"
                            />
                          );
                        })

                      )}
                    </div>
                  </>
                ) : (
                  <p style={{ fontSize: 12, color: "#98a2b3", paddingTop: 16 }}>
                    Select a filter from the left
                  </p>
                )}
              </div>

              <div className="filter_tab_footer">
                <button className="reset_aply_btn mb-1" onClick={handleReset}>
                  Reset
                </button>
                <button className="apply_btn mb-1" onClick={handleApply}>
                  Apply Filter
                </button>
              </div>
            </Col>
          )} */}

          </div>
        </div>
      )}
    </div>
  );
};

export default TableFilterMorePanel;